import { useEffect, useState } from 'react';

import Template from '@/ui/templates/lp/Base';
import Head from '@/ui/utils/Head';
import { isDiscounted as queryIsDiscounted } from '@/utils/myshands-api';

import type { NextPage } from 'next';

const Page: NextPage = () => {
  const [isDiscounted, setIsDiscounted] = useState<boolean | null>(null);

  // 値引き期間かどうかをmyshandsサーバーに問い合わせる
  useEffect(() => {
    (async () => {
      setIsDiscounted(await queryIsDiscounted());
    })();
  }, []);

  return (
    <>
      <Head title="動画でまなぶ卓球 シェークハンズ" description="">
        {/* 分析のノイズにならないよう、LPにGoogle検索から直接流入は防ぐ */}
        <meta name="robots" content="noindex" />
      </Head>
      <Template isDiscounted={isDiscounted} />
    </>
  );
};

export default Page;
